import React from 'react'
import BuildItemWidget from '../../BuildItemWidget'
import './style.css'

const RightPane = ({ selectedBuildItemType }) => (
  <div className="home-body-right-pane">
    <BuildItemWidget selectedBuildItemType={selectedBuildItemType} />
  </div>
)

export default RightPane
